import { Duration, Schedule } from 'effect';

import { isConflictError } from '../../data/error/backendApi/_internal/createBackendApiError';

/**
 * Sylius guards each order line with an optimistic lock
 * (`sylius_order_item.version`; the order row itself has no version). Two
 * writes racing on the same line make the loser fail its version check, and
 * the backend answers `409 Conflict` with the whole transaction rolled back —
 * nothing was persisted, so replaying the request is safe and is what the
 * status asks for.
 *
 * Only order mutations wear this: a 409 on any other endpoint is not a lock
 * collision and must surface to the caller unretried.
 *
 * Backs off 150 ms then 300 ms, each jittered by ±20% so retries from parallel
 * losers spread out instead of colliding again in lockstep. Any failure that is
 * not a 409 stops the schedule on its first step and propagates unchanged.
 */
const CONFLICT_RETRY_TIMES = 2;
const CONFLICT_RETRY_BASE_DELAY = Duration.millis(150);

export const orderConflictRetryPolicy = Schedule.exponential(CONFLICT_RETRY_BASE_DELAY).pipe(
  Schedule.jittered,
  Schedule.upTo({ times: CONFLICT_RETRY_TIMES }),
  Schedule.while((meta) => isConflictError(meta.input))
);
